<div class='outer' (click)='toggle()' (keypress)='$event.key==="Enter"? toggle(): null' tabindex="0">
  <div class='inner' [class.active]='active'>
  </div>
</div>